// src/utils/validationRules.js
import { helpers, required, email } from "@vuelidate/validators";

export const validationRules = {
  personal: {
    email: {
      required: helpers.withMessage("Email is required", required),
      email: helpers.withMessage("Invalid email format", email),
    },

    fullName: {
      required: helpers.withMessage("Name is required", required),
    },

    telephone: {
      required: helpers.withMessage("Telephone is required", required),
    },

    birthDate: {
      required: helpers.withMessage("Date of Birth is required", required),
    },

    gender: {
      required: helpers.withMessage("Gender is required", required),
    },

    registrationDate: {
      required: helpers.withMessage("Registration Date is required", required),
    },

    // referSource: {
    //   required: helpers.withMessage("Field is required", required),
    // },

    gdprAgreement: {
      required: helpers.withMessage(
        "GDPR Agreement must be accepted",
        (value) => value === true
      ),
    },
  },
  route: {
    branchId: {
      required: helpers.withMessage("Branch is required", required),
    },
    // projects: {
    //   required: helpers.withMessage("Project is required", required),
    // },
  },
  services: {
    // employabilityOfficerId: {
    //   required: helpers.withMessage(
    //     "Employability Officer is required",
    //     required
    //   ),
    // },
  },
};
